import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import hackathon1 from "../static/img/hackathon1.jpg";
import hackathon2 from "../static/img/hackathon2.jpg";
import hackathon3 from "../static/img/hackathon3.jpg";

import "./Microcredit.style.scss";

const HackathonTraining: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "UA Hackathon Training DOMANI " :
                    "Тренінг з організації онлайн-хакатонів за проєктом Erasmus+ DOMANI"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        &nbsp; &nbsp;On March 4, 2026, as part of the Erasmus+ DOMANI project (Development of Microcredit
                        Ecosystems in Ukraine and Mongolia for a Competitive and Sustainable Green Economy), the online
                        training "UA Hackathon Training DOMANI" was successfully held. The event was dedicated to mastering
                        modern hackathon techniques and sharing best practices among project participants.<br/>
                        &nbsp; &nbsp;The speakers at the training session were European partners of the project: Attila
                        Katona (Center for System Innovation, Hungary) and Ochir Altansukh (National University of Mongolia).
                        The experts presented the basics of hackathon technology and shared valuable insights and "tricks"
                        that are critical for the successful organization of online events. Eleven participants of the DOMANI
                        project, including representatives of all Ukrainian organizations (Taras Shevchenko National University
                        of Kyiv; V. N. Karazin Kharkiv National University; Ukrainian United Meteorological and Hydrological
                        Scientific Society), actively participated in the training.<br/>
                        &nbsp; &nbsp;During the event, participants received comprehensive answers to all their questions and
                        actively discussed the prospects of organizing a national hackathon in Ukraine using the knowledge they
                        had gained.
                    </>)
                    :
                    (<>
                        &nbsp; &nbsp;4 березня 2026 року в рамках проєкту Еразмус+ DOMANI (Розвиток мікро-кредитних екосистем
                        в Україні та Монголії для конкурентоспроможної та стійкої зеленої економіки) успішно пройшов онлайн-тренінг
                        «UA Hackathon Training DOMANI». Захід було присвячено опануванню сучасних методик проведення хакатонів та
                        поширенню кращих практик серед учасників проєкту.<br/>
                        &nbsp; &nbsp;Спікерами тренінгу виступили європейські партнери проєкту: Attila Katona (Центр системних
                        інновацій, Угорщина) та Ochir Altansukh (Національний університет Монголії). Експерти презентували основи
                        технології проведення хакатонів, поділилися цінними інсайтами та «хитрощами», які є критично важливими для
                        успішної організації заходів саме в онлайн-форматі.<br/>
                        &nbsp; &nbsp;Особливу увагу було приділено питанням безпеки, що сьогодні є надзвичайно актуальним для України.
                        Спікери детально розповіли:<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;•	Про можливості використання інтерактивних онлайн-дошок для ефективної організації
                        роботи віддалених команд.<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;•	Про дієві айсбрейкінг-активності, які дозволяють швидко згуртувати учасників та
                        створити робочу атмосферу.<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;•	Про принципи формування команд та ефективної організації менторської підтримки
                        під час хакатону.<br/>
                        &nbsp; &nbsp;Активними учасниками тренінгу стали 11 учасників проєкту DOMANI, у т.ч. представники всіх
                        українських організацій (Київський національний університет імені Тараса Шевченка; Харківський національний
                        університет імені В. Н. Каразіна; Українське об’єднане метеорологічне та гідрологічне наукове товариство).<br/>
                        &nbsp; &nbsp;Під час заходу учасники отримали вичерпні відповіді на всі свої запитання, а також жваво
                        обговорили перспективи організації національного хакатону в Україні, використовуючи отримані знання.<br/>
                        &nbsp; &nbsp;Отримані знання та  поширені організаторами напрацювання будуть використані для практичної
                        реалізації хакатонів в Україні у межах проєкту DOMANI, спрямованих на пошук рішень для конкурентоспроможної
                        та стійкої зеленої економіки.
                    </>)
                }
            </p>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={hackathon1} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={hackathon2} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={hackathon3} alt="training" style={{ width: '100%',height:'100%' }} />
                {/*<img src={training4} alt="training" style={{ width: '100%',height:'90%' }} />*/}
                {/*/!* <img src={training5} alt="training" style={{ width: '100%' }} />*/}
                {/*<img src={training6} alt="training" style={{ width: '100%' }} /> *!/*/}
            </div>
        </div>
    )
}
export default HackathonTraining;